// Shared types for internationalize models to avoid circular dependencies

export enum Locale {
  EnglishUnitedStates = 'en-US',
  EnglishAustralia = 'en-AU',
  EnglishUnitedKingdom = 'en-GB',
  EnglishCanada = 'en-CA',
  GermanGermany = 'de-DE',
  GermanAustria = 'de-AT',
  Default = 'en-US',
  EnglishBeta = 'uz-UZ',
  SpanishMexico = 'es-MX',
  FrenchCanada = 'fr-CA',
}

// Types of locales for languages for class content may differ from Locale,
// which was introduced when display and content languages were assumed to be the same.
export enum ContentLocale {
  EnglishUnitedStates = 'en-US',
  EnglishAustralia = 'en-AU',
  EnglishUnitedKingdom = 'en-GB',
  EnglishCanada = 'en-CA',
  GermanGermany = 'de-DE',
  GermanAustria = 'de-AT',
  SpanishSpain = 'es-ES',
  EnglishBeta = 'uz-UZ',
  SpanishMexico = 'es-MX',
  FrenchCanada = 'fr-CA',
}

export enum Language {
  English = 'en',
  German = 'de',
  Spanish = 'es',
  PseudoLocalization = 'pseudo-localization',
  EnglishBeta = 'uz',
  French = 'fr',
}
